import React from "react";
import {
  Button,
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  Grid,
  TextField,
} from "@mui/material";
import { Edit } from "react-admin";
import { useNavigate, useParams } from "react-router-dom";

import { DishCategoryTagService } from "../../services/DishCategoryTagService";
import EventBus from "../../EventBus";
import { EventBusEventsEnum } from "../../enums/EventBusEventsEnum";
import { CustomSnackbarTypes } from "../Common/CustomSnackBar";
import DishCategoryIconUploader from "./DishCategoryIconUploader";

const dishCategoryTagService = new DishCategoryTagService();

function EditDishCategoryTag() {
  const navigate = useNavigate();
  const { id } = useParams();
  const tagId = Number(id);

  const [name, setName] = React.useState<string>("");
  const [slug, setSlug] = React.useState<string>("");
  const [iconUrl, setIconUrl] = React.useState<string>("");
  const [isActive, setIsActive] = React.useState<boolean>(true);
  const [loading, setLoading] = React.useState<boolean>(true);

  React.useEffect(() => {
    const fetchTag = async () => {
      try {
        const res = await dishCategoryTagService.getTagById(tagId);
        const tag = res?.data;
        if (tag) {
          setName(tag.name ?? "");
          setSlug(tag.slug ?? "");
          setIconUrl(tag.iconUrl ?? "");
          setIsActive(!!tag.isActive);
        }
      } catch {
        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
          message: "Failed to load dish category tag",
          type: CustomSnackbarTypes.ERROR,
        });
      } finally {
        setLoading(false);
      }
    };
    if (tagId) fetchTag();
  }, [tagId]);

  const updateTag = async () => {
    if (!name) {
      EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
        message: "Name is required",
        type: CustomSnackbarTypes.ERROR,
      });
      return;
    }

    const payload: any = { name, isActive, slug, iconUrl };

    try {
      await dishCategoryTagService.updateTag(tagId, payload);
      EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
        message: "Updated Successfully",
        type: CustomSnackbarTypes.SUCCESS,
      });
      navigate(`/DishCategoryTag/${tagId}/show`);
    } catch (error) {
      EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
        message: "Failed to update dish category tag",
        type: CustomSnackbarTypes.ERROR,
      });
    }
  };

  if (loading) {
    return (
      <Grid container justifyContent="center" style={{ padding: "40px" }}>
        <CircularProgress size={28} />
      </Grid>
    );
  }

  return (
    <Edit title={"Edit Dish Category Tag"}>
      <Grid container columns={1} rowSpacing={1} style={{ padding: "12px" }}>
        <Grid item xs={4}>
          <FormControl style={{ width: "230px" }}>
            <TextField
              label="Name"
              value={name}
              type="text"
              onChange={(event: any) => setName(event.target.value)}
            />
          </FormControl>
        </Grid>
        <Grid item xs={4}>
          <FormControl style={{ width: "230px" }}>
            <TextField
              label="Slug"
              value={slug}
              type="text"
              onChange={(event: any) => setSlug(event.target.value)}
            />
          </FormControl>
        </Grid>
        <Grid item xs={4}>
          <DishCategoryIconUploader
            name={name}
            iconUrl={iconUrl}
            onUploaded={(url) => setIconUrl(url)}
          />
        </Grid>
        <Grid item xs={4}>
          <FormControlLabel
            control={
              <Checkbox
                checked={isActive}
                onChange={(e) => setIsActive(e.target.checked)}
                name="Active"
              />
            }
            label="Active"
          />
        </Grid>
        <Grid item xs={12}>
          <FormControl style={{ width: "230px" }}>
            <Button onClick={updateTag} variant="contained">
              Update Tag
            </Button>
          </FormControl>
        </Grid>
      </Grid>
    </Edit>
  );
}

export default EditDishCategoryTag;
